import { network } from './network'
import { TOKEN_STORAGE_KEY } from '@query/constants'

export const initializeNetworkToken = () => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const storedToken = window.sessionStorage?.getItem(TOKEN_STORAGE_KEY) || undefined
    network.setBearerToken(storedToken)
  } catch {
    network.setBearerToken(undefined)
  }
}
